import { Dispatch, FC, SetStateAction, useState } from 'react';
import alertSvg from '../../assets/images/alert.svg';
import sbp from '../../assets/images/sbp.png';
import card from '../../assets/images/card.svg';
import link from '../../assets/images/link.svg';
import crypto from '../../assets/images/crypto.svg';
import cryptoLight from '../../assets/images/cryptoLight.svg';
import m10Logo from '../../assets/images/m10.svg';
import Container from '../../components/atoms/Container/Container';
import Field from '../../components/atoms/Field/Field';
import Button from '../../components/atoms/Button/Button';
import { Transaction } from '../../services/types';
import { getCurrencySymbol } from '../../services/utils';
import Header from '../../components/organisms/Header/Header';
import SupportButton from '../../components/atoms/SupportButton/SupportButton';
import styles from './CancellationPage.module.scss';
import NewMethodBlock from '../../components/organisms/NewMethodBlock/NewMethodBlock';
import useTheme from '../../hooks/useTheme';

interface CancellationPageProps {
  transaction: Transaction;
  timeLeft: string;
  merchantName?: string;
  merchantImage?: string;
  currency?: string;
  ticketId?: string;
  paymentMethod?: string;
  paymentMethodImage?: string;
  amount?: number;
  onConfirm: () => void;
  setRetry: Dispatch<SetStateAction<number>>;
  uuid?: string;
  transgranError?: boolean;
  setTransgranError: Dispatch<SetStateAction<boolean>>;
  setLoading?: Dispatch<SetStateAction<boolean>>;
}

const CancellationPage: FC<CancellationPageProps> = ({
  transaction,
  timeLeft,
  amount,
  onConfirm,
  paymentMethod,
  ticketId,
  setRetry,
  currency,
  uuid,
  setTransgranError,
  setLoading,
}) => {
  const [showTransgran, setShowTransgran] = useState<boolean>(true);
  // Пока реквизит в ответе есть, валюта приходит из него; на этом экране его уже нет, и валюту
  // называет сам тикет. Не пришло ни то, ни другое — считаем рубли, как было до этого.
  const currencySign = getCurrencySymbol(currency || 'RUB')?.trim();
  const theme = useTheme();

  const retryHandler = () => {
    if (typeof setRetry === 'function') {
      setRetry((prev) => prev + 1);
    }
  };

  const getPaymentMethodInfo = (
    paymentMethod: string | undefined,
    type: string | undefined
  ) => {
    if (type === 'redirect_url') {
      return { img: link, text: 'Оплата по ссылке' };
    }

    switch (paymentMethod) {
      case 'MC/VISA/MIR P2P RUB':
        return { img: card, text: 'По номеру карты' };
      case 'P2P MATCHING RUB':
        return { img: card, text: 'По номеру карты' };
      case 'SBP P2P RUB':
        return { img: sbp, text: 'Пополнение через СБП' };
      case 'SBP MATCHING RUB':
        return { img: sbp, text: 'Пополнение через СБП' };
      case 'TRANS SBP P2P RUB':
        return { img: sbp, text: 'Пополнение через СБП' };
      case 'OZON SBP RUB':
        return { img: sbp, text: 'Пополнение через СБП Озон банком' };
      case 'ALFA SBP RUB':
        return { img: sbp, text: 'Пополнение через СБП Альфа Банком' };
      case 'SBER SBP RUB':
        return { img: sbp, text: 'Пополнение через СБП Сбербанком' };
      case 'VTB SBP RUB':
        return { img: sbp, text: 'Пополнение через СБП ВТБ Банком' };
      case 'TBANK SBP RUB':
        return { img: sbp, text: 'Пополнение через СБП Т-Банком' };
      case 'CRYPTO':
        return {
          img: theme === 'dark' ? cryptoLight : crypto,
          text: 'Криптовалюта',
        };
      case 'A2A RUB':
        return { img: card, text: 'По номеру счёта' };
      case 'MC/VISA P2P KZT':
        return { img: card, text: 'По номеру карты (казахстанский тенге)' };
      case 'MOBILE P2P KZT':
        return { img: sbp, text: 'По номеру телефона (казахстанский тенге)' };
      case 'M10AZN':
        return { img: m10Logo, text: 'M10 Перевод по номеру телефона' };
      case 'MC/VISA P2P KRW':
        return { img: card, text: 'По номеру карты (южнокорейская вона)' };
      case 'SBER TRANS QR P2P RUB':
        return { img: sbp, text: 'Оплата по QR-коду' };
      default:
        break;
    }
  };

  return (
    <div className={styles.wrapper}>
      <Header
        transaction={transaction}
        ticketId={ticketId || ''}
        timeLeft={timeLeft}
      />

      <div className={styles.supportWrapper}>
        {transaction.merchant.toLowerCase() === 'vocxod' && (
          <SupportButton userId={transaction.externalUserId} />
        )}
      </div>
      <Container className={styles.container}>
        <div className={styles.contentWrapper}>
          <div className={styles.headWrapper}>
            <img src={alertSvg} alt='error' />
          </div>
          <div className={styles.fieldGroup}>
            <Field
              bold
              text={`${amount || 0}.00 ${currencySign}`}
              border='#FF857E'
              center
              fontSize='20px'
            />
            <Field
              text={
                getPaymentMethodInfo(paymentMethod, transaction.requisite.type)
                  ?.text
              }
              image={
                getPaymentMethodInfo(paymentMethod, transaction.requisite.type)
                  ?.img
              }
              border='#FF857E'
              center
            />
            <p className={styles.errorText}>
              Не удалось обработать ваш&nbsp;платеж.
            </p>
            <Button
              variant='error'
              onClick={onConfirm}
              outlined
              dataSentryElement='cancellation-confirm'
            >
              Отмена
            </Button>
          </div>
        </div>
      </Container>
      {transaction?.recreationPaymentMethods.length > 0 &&
      uuid &&
      showTransgran ? (
        // <Container className={styles.methodBlockWrapper}>
        //   <NewMethodBlock
        //     transaction={transaction}
        //     uuid={uuid}
        //     setShowTransgran={setShowTransgran}
        //     setTransgranError={setTransgranError}
        //     setLoading={setLoading}
        //   />
        // </Container>
          <></>
      ) : (
        <></>
      )}
    </div>
  );
};

export default CancellationPage;
